import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FetchArgs } from '@aya/controls/aya-table';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { CandidateSearch } from 'src/app/recruiting/locums-margin-calculator/models/candidate-search.models';
import { appendQuery, arrayToQuery, combine } from 'src/app/shared/utilities/route';
import { CandidateDetails } from '../models/candidate-details.models';

@Injectable({ providedIn: 'root' })
export class CandidateService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    rapidSearchLocumsCandidates(args: FetchArgs): Observable<CandidateSearch[]> {
        let url = combine(this.coreApiPath, 'locums/candidates/rapid-search');
        url = this.generateUrl(args, url);
        return this.http.get<CandidateSearch[]>(url);
    }

    getCandidateDetails(candidateId: number): Observable<CandidateDetails> {
        const url = combine(this.coreApiPath, `locums/candidates/${candidateId}`);
        return this.http.get<CandidateDetails>(url);
    }

    private generateUrl(args: FetchArgs, url: string) {
        if (args.filter) {
            for (const filterName in args.filter) {
                const val = encodeURIComponent(args.filter[filterName]);

                if (Array.isArray(val)) {
                    url = appendQuery(url, arrayToQuery(`filter.${filterName}`, val as any[]));
                } else if (val) {
                    url = appendQuery(url, `filter.${filterName}=${val}`);
                }
            }
        }

        if (args.sort && args.sort.field.length) {
            url = appendQuery(
                url,
                `sort.field=${args.sort.field}&sort.type=${args.sort.dir === 'asc' ? 'asc' : 'desc'}`
            );
        }

        url = appendQuery(url, `pageSize=${args.pageSize}`, `skip=${args.skip}`);
        return url;
    }
}
